import { createModelStore } from '@/shared/stores/create-model-store'
import { model15InitialModel } from './initial-state'
import { model15DimensionHandlers } from './dimensions'

export const useModel15Store = createModelStore({
  initialModel: model15InitialModel,
  dimensionHandlers: model15DimensionHandlers,
})
